<template>
  <div class="home flex-column">
    <div class="title-container">
      <img class="logo" src="@/assets/new/new_footer.png" />
    </div>
    <div class="content flex-column">
      {{ $t('field-user-login-condition') }}
      <div class="inactive-tab">
        <span>{{ $t('entity') }}</span>
        <div>
          <input v-model="entityParam" />
          <button style="margin-left: 15px" @click="entityParam = ''">{{ $t('clear') }}</button>
        </div>
      </div>
      <div class="inactive-tab">
        <span>UID</span>
        <input v-model="uidParam" />
      </div>
      <div class="inactive-tab">
        <span>{{ $t('domain') }}</span>
        <Multiselect
          v-model="roleDomainOption"
          :options="roleDomainOptions"
          class="multiselect single"
          :placeholder="$t('select-option')"
          track-by="domain"
          label="name"
          :showLabels="false"
          @select="
            getBCsList($event);
            getDistrictsList($event);
          "
        ></Multiselect>
      </div>
      <div class="inactive-tab">
        <span>{{ $t('role') }}</span>
        <Multiselect
          v-model="roleOption"
          :options="roles"
          class="multiselect single"
          :placeholder="$t('select-option')"
          track-by="name"
          label="description"
          :showLabels="false"
        ></Multiselect>
      </div>
      <div class="inactive-tab" v-if="showDropdowns">
        <span>BC</span>
        <Multiselect
          v-model="bc"
          :options="bcList"
          class="multiselect single"
          :placeholder="$t('select-option')"
          :showLabels="false"
        ></Multiselect>
      </div>
      <div class="inactive-tab" v-if="showDropdowns && roleOption && roleOption.name === 'service-am'">
        <span>{{ $t('service-district') }}</span>
        <Multiselect
          v-model="serviceDistrict"
          :options="serviceDistrictList"
          class="multiselect single"
          :placeholder="$t('select-option')"
          :showLabels="false"
        ></Multiselect>
      </div>
      <div class="inactive-tab" v-if="showDropdowns && roleOption && roleOption.name === 'sales-am'">
        <span>{{ $t('sales-district') }}</span>
        <Multiselect
          v-model="salesDistrict"
          :options="salesDistrictList"
          class="multiselect single"
          :placeholder="$t('select-option')"
          :showLabels="false"
        ></Multiselect>
      </div>
      <button class="signIn" @click="login">{{ $t('sign-in') }}</button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

const roleDomainOptions = [
  {
    name: 'US CF',
    domain: 'US CF',
  },
  {
    name: 'US CED',
    domain: 'US CED',
  },
  {
    name: 'US ALFA QBP',
    domain: 'US ALFA',
  },
  {
    name: 'US ALFA NPS',
    domain: 'US ALFA NPS',
  },
  {
    name: 'US Wgnr',
    domain: 'US Wgnr',
  },
  {
    name: 'US DPB',
    domain: 'US DPB',
  },
  {
    name: 'US EVR',
    domain: 'US EVR',
  },
  {
    name: 'US EL',
    domain: 'US EL',
  },
  {
    name: 'US PM',
    domain: 'US PM',
  },
  {
    name: 'US SVC',
    domain: 'US SVC',
  },
  {
    name: 'Can CF',
    domain: 'Can CF',
  },
  {
    name: 'Can Wgnr',
    domain: 'Can Wgnr',
  },
  {
    name: 'PR CF',
    domain: 'PR CF',
  },
  {
    name: 'PR ALFA',
    domain: 'PR ALFA',
  },
  {
    name: 'PR Wgnr',
    domain: 'PR Wgnr',
  },
  {
    name: 'CX QA US',
    domain: 'CX QA US',
  },
  {
    name: 'CX Test US',
    domain: 'CX Test US',
  },
];

export default {
  name: 'Login',
  components: { Multiselect },
  data() {
    return {
      userName: null,
      password: null,
      userInfo: null,
      entityParam: '05002',
      uidParam: 'T2214K1',
      roles: [],
      userRole: null,
      roleDomainOption: null,
      roleOption: null,
      roleDomainOptions,
      bc: null,
      bcList: [],
      serviceDistrict: null,
      serviceDistrictList: [],
      salesDistrict: null,
      salesDistrictList: [],
      showDropdowns: false,
    };
  },
  methods: {
    view() {
      return null;
    },
    getRoles() {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getRoles')
        .then((res) => {
          this.roles = res;
        })
        .catch(() => {
          this.$store.dispatch('logout');
        })
        .finally(() => {
          loader.hide();
        });
    },
    getBCsList(selectedOption) {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getBcLevels', { domains: selectedOption.domain })
        .then((res) => {
          this.bcList = res.map((bcObj) => bcObj.bc);
        })
        .catch(() => {
          this.$store.dispatch('logout');
        })
        .finally(() => {
          loader.hide();
        });
    },
    getDistrictsList(selectedOption) {
      const loader = this.$loading.show();
      this.$store
        .dispatch('getDistrictLists', { domain: selectedOption.domain })
        .then((res) => {
          this.serviceDistrictList = res.serviceDistArr;
          this.salesDistrictList = res.salesDistArr;
        })
        .catch(() => {
          this.$store.dispatch('logout');
        })
        .finally(() => {
          loader.hide();
        });
    },
    login() {
      const loader = this.$loading.show();

      const { entityParam, uidParam, bc, serviceDistrict, salesDistrict } = this;
      let role = null;
      let roleDomain = null;

      if (this.roleOption && this.roleDomainOption) {
        role = this.roleOption.name;
        roleDomain = this.roleDomainOption.domain;
      }

      this.$store
        .dispatch('devLogin', { entityParam, uidParam, role, roleDomain, bc, serviceDistrict, salesDistrict })
        .then(() => {
          this.assignRole();
          this.navigateUser();
          loader.hide();
        });
    },
    assignRole() {
      if (this.loginInfo.entity && this.loginInfo.entity !== 'NA' && this.loginInfo.domain) {
        this.$store.state.userType = 'Dealer';
        if (
          this.loginInfo.roles[0] &&
          (this.loginInfo.roles[0].roleDetails.name === 'sales-am' ||
            this.loginInfo.roles[0].roleDetails.name === 'service-am')
        ) {
          this.$store.state.userType = 'Field User';
        }
      } else {
        this.$store.state.userType = 'Field User';
      }
    },
    navigateUser() {
      if (this.$store.state.userType === 'Field User') {
        this.$router.push({
          name: 'Programs',
        });
      } else if (this.$route.name !== 'Dashboard') {
        this.getNavPermissions(this.loginInfo.domain);
        this.$router.push({
          name: 'Dealer',
        });
      }
    },
    getNavPermissions(program) {
      const loader = this.$loading.show();

      const domain = program;

      this.$store
        .dispatch('global/getNavPermissions', { domain })
        .then((res) => {
          this.$store.state.global.navPermissions = res;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  computed: {
    loginInfo() {
      return this.$store.state.login.loginInfo;
    },
  },
  watch: {
    roleOption(roleVal) {
      this.$store.state.global.roleName = roleVal.description;
      // The code below will only display bc & district dropdowns if the role category starts with 'BC'
      this.showDropdowns =
        roleVal?.category.toLowerCase().startsWith('bc') ||
        roleVal?.name === 'program-reviewer' ||
        roleVal?.name === 'alt-program-reviewer-1' ||
        roleVal?.name === 'alt-program-reviewer-2';
    },
  },
  created() {
    if (process.env.VUE_APP_DEPLOY_ENV === 'prod') {
      this.$store.dispatch('logout');
    }
    this.getRoles();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.multiselect {
  width: 100%;
}

.content {
  position: relative;
  padding-top: 40px;
  transform: translate(-1%, -1%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.inactive-tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  margin-left: 5px;
}

.inactive-tab input,
.inactive-tab .multiselect {
  width: 282px;
}

.logo {
  vertical-align: center;
  width: 280px;
  margin-top: 10px;
}

.signIn {
  margin-top: 40px;
}

.title-container {
  border-bottom: 1px #dfe4e8 solid;
  padding-bottom: 20px;
}

a {
  font-size: 15px;
  display: inline-block;
  background: #4f73d7;
  color: #fff;
  text-transform: uppercase;
  padding: 15px 15px 15px 15px;
  text-align: center;
  cursor: pointer;
  position: relative;
  width: 105px;
  max-width: 250px;
  text-decoration: none;
  border-style: none;
}

@media (max-width: 769px) {
  .content {
    height: 57%;
  }
}
</style>
